import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function RefinancingPage() {
  return (
    <LoanProgramTemplate
      title="Refinancing"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907424/Refinancing_sav8rv.png"
      descriptionBold="Refinancing"
      description="allows homeowners to adjust their mortgage to better match their financial goals—potentially lowering payments, changing terms, or accessing equity. Typical refinance options can include rate and term refinancing, cash out refinancing, and streamlined programs for eligible FHA, VA, or USDA loans."
      whyBuyersConsider="Refinancing can help homeowners align their mortgage with current needs, whether that means lowering monthly payments, shortening the loan term, or using equity for other priorities."
      eligibilityItems={[
        'Minimum credit score requirements depend on loan type',
        'Some refinances require a specific amount of home equity',
        'Standard income and documentation apply',
        'Closing costs apply and may be financed into the loan',
      ]}
      benefitsItems={[
        'Opportunity to reduce monthly payments',
        'Ability to shorten the overall loan term',
        'Access to built-up home equity',
        'Possibility of removing mortgage insurance when guidelines allow',
      ]}
    />
  );
}
